<template>
  <PropertyDetailsCardRows>
    <PropertyDetailsCardInfoItem
      v-if="property?.renterRequirements?.minimumIncome"
      label="Monthly income"
      icon="coins-01"
      :value="property?.renterRequirements?.minimumIncome"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.renterRequirements?.minimumCreditScore"
      label="Credit score"
      icon="speedometer-03"
      :value="property.renterRequirements.minimumCreditScore"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.renterRequirements?.acceptsCosigners"
      label="Accepts co-signers"
      icon="users-01"
      :value="property?.renterRequirements?.acceptsCosigners ? 'Yes' : 'No'"
    />

    <PropertyDetailsCardInfoItem
      v-if="property?.renterRequirements?.screeningSensitivity"
      label="Renter qualification"
      icon="sliders-04"
      :value="property?.renterRequirements?.screeningSensitivity"
    />
  </PropertyDetailsCardRows>
</template>

<script setup lang="ts">
import { PropertyDto } from '../../model/property';
import PropertyDetailsCardInfoItem from './property-details-card/property-details-card-info-item.vue';
import PropertyDetailsCardRows from './property-details-card/property-details-card-rows.vue';

defineProps<{
  property: PropertyDto | null | undefined;
}>();
</script>
